module.exports = __webpack_public_path__ + "static/media/Home_Background_Particles4.27c2356e.svg";